
import React from 'react';
import { useDispatch } from 'react-redux';
import { IoMdTime } from 'react-icons/io';
import { FaRegCheckCircle } from 'react-icons/fa';
// import TabComponent from '../TabComponent';

import TabComponent from '../../../Components/TabComponent/TabComponent';
import PurchaseApprovalApproved from './PurchaseApprovalApproved';
import PurchaseApprovalPending from './PurchaseApprovalPending';
import { setHeaderName } from '../../../ReduxStore/Slices/headerSlice';
// import { IoMdTime } from "react-icons/io";

const PurchaseApprovalTabs = () => {
    const dispatch = useDispatch();

    React.useEffect(() => {
        dispatch(setHeaderName("Purchase Approval"));
    }, [dispatch]);

    const tabsHeadData = [
        { label: 'Pending', icon: <IoMdTime /> },
        { label: 'Approved', icon: <FaRegCheckCircle /> },
    ];

    const tabsComponent = [
        <PurchaseApprovalPending />,

        <PurchaseApprovalApproved />,
    ];

    return (
        <div>
            <TabComponent tabsData={tabsHeadData} tabComponents={tabsComponent} />
        </div>
    );
};

export default PurchaseApprovalTabs;
